export default __webpack_public_path__ + "static/media/card-experience.0714c461.png";